const isMobile = $('body').hasClass('mobile-body');
module.exports = {
  success(msg){

  },
  error(msg){

  },
  warn(msg){

  },
  alert(msg, time = 2){
    if (isMobile) {
      return layer.open({
        content: msg, skin: 'msg', time
      });
    } else {
      return layer.alert(msg);
    }
  }
};